import axios from "axios";
import { SERVER_URL } from "../socket";

export async function loadSignatureSettings(headers) {
  const res = await axios.get(`${SERVER_URL}/api/settings`, { headers });
  return res.data || {};
}

export async function createSignature(payload, headers) {
  const res = await axios.post(`${SERVER_URL}/api/settings/signatures`, payload, { headers });
  return res.data || {};
}

export async function updateSignature(signatureId, payload, headers) {
  const res = await axios.put(`${SERVER_URL}/api/settings/signatures/${signatureId}`, payload, { headers });
  return res.data || {};
}

export async function deleteSignature(signatureId, headers) {
  const res = await axios.delete(`${SERVER_URL}/api/settings/signatures/${signatureId}`, { headers });
  return res.data || {};
}

export async function setDefaultSignature(signatureId, headers) {
  const res = await axios.post(`${SERVER_URL}/api/settings/signatures/${signatureId}/default`, {}, { headers });
  return res.data || {};
}
export async function getStorageInfo(headers) {
  const res = await axios.get(`${SERVER_URL}/api/storage`, { headers });
  return res.data || {};
}